import React, { useState, useContext, useCallback } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import styled from "styled-components";
import useEntitesTable from "./useEntitesTable.js";
import Button from "components/CustomButtons/Button.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import CustomCommentDialog from "components/CustomCommentDialog/CustomCommentDialog.js";
import SelectedFiles from "./SelectedFiles.js";
import EditUserDialog from "./EditUserDialog";
import UserService from "services/UserService";

import AdvancedSearchContext from "context/AdvancedSearchContext";

import { withStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";

import {downloadFile,getSite} from "services/ConfigServices"

import { compte } from "variables/patrimoine.js";

//import "react-table/react-table.css";

// @mui/icons-material
import Edit from "@mui/icons-material/Edit";
import Close from "@mui/icons-material/Close";
import AttachFileIcon from "@mui/icons-material/AttachFile";

//import Button from "components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const styless = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
  button: {
    backgroundColor: "",
    bordertopleftradius: 0,
    borderbottomleftradius: 0,
    bordertoprightradius: "5px",
    borderbottomrightradius: "5px",
    height: "34px",
    width: "32px",
    textalign: "center",
    display: "flex",
    alignitems: "center",
    justifycontent: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
});

const DialogTitle = withStyles(styless)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;

const ExpandableComponent = props => {
  const { data } = props;
  return (
    <Container>
      <ExpandableContainer>
        <ExpandableElement>
          <ElementTitle>{compte.contact.contactlist.phone} : </ElementTitle>
          <ElementData>{data.phone}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{compte.contact.contactlist.email} : </ElementTitle>
          <ElementData>{data.email}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{compte.contact.contactlist.comments} : </ElementTitle>
          <ElementData>{data.comments}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
        <ElementTitle>{compte.contact.contactlist.associatedfiles} : </ElementTitle>          
          <ElementData>{data.ged.map((file, index) => (
            <Chip label={file.fileName} onClick={downloadGED(file.fileId, file.fileName)} />
          ))}</ElementData>
        </ExpandableElement>
      </ExpandableContainer>
    </Container>
  );
};

const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};

const RTContacts = () => {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");

  const { gridState, error, refetch, invalidate } = useEntitesTable();

  const [open, setOpen] = useState(false);
  const [openEditFiles, setOpenEditFiles] = useState(false);

  const [clef, setClef] = useState();
  const [comments, setComments] = useState();
  const [external, setExternal] = useState();
  console.log(external);
  const [description, setDescription] = useState();
  const [ged, setGed] = useState([]);
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [role, setRole] = useState("");
  const [company, setCompany] = useState("");
  const [phone, setPhone] = useState("");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const updateState = useCallback((state) => console.log(state));

  const classes = useStyles();

  const fillButtons = [
    { color: "success", icon: Edit },
    { color: "danger", icon: Close },
  ].map((prop, clef) => {
    return (
      <Button
        color={prop.color}
        className={classes.actionButton}
        clef={clef}
        onClick={prop.onClick}
      >
        <prop.icon className={classes.icon} />
      </Button>
    );
  });

  let dataUsers = gridState.data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleEditFilesOpen = () => {
    setOpenEditFiles(true);
  };
  const handleEditFilesClose = () => {
    setOpenEditFiles(false);
  };

  //if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Il semble y avoir une erreur...{" "}
  //       <button onClick={refetch}>Relancer</button>
  //     </p>
  //   );
  // }

  const columns = [
    {
      name: compte.contact.contactlist.name,
      selector: row => row.name,
      sortable: true,
      maxWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">{row.name}</div>
        </>
      ),
    },
    {
      name: compte.contact.contactlist.key,
      selector: row => row.clef,
      sortable: true,
    },
    {
      name: compte.contact.contactlist.status,
      selector: row => row.status,
      sortable: true,
    },
    {
      name: compte.contact.contactlist.role,
      selector: row => row.role,
      sortable: true,
    },
    {
      name: compte.contact.contactlist.company,
      selector: row => row.company,
      sortable: true,
    },
    {
      name: compte.contact.contactlist.external,
      selector: row => row.external,
      sortable: true,
      minWidth: "10rem",
      // eslint-disable-next-line react/display-name
      cell: (row) =>
        row.external == "intern" ? (
          <div>Interne</div>
          // <Chip
          //   label="Interne"
          //   style={{
          //     color: "#008083",
          //     borderRadius: "8px",
          //     backgroundColor: "rgba(0, 128, 131, 0.2)",
          //     fontWeight: "bold",
          //   }}
          // />
        ) : row.external == "extern" ? (
          <div>Externe</div>
          // <Chip
          //   label="Externe"
          //   style={{
          //     color: "#FF432D",
          //     borderRadius: "8px",
          //     backgroundColor: "rgba(255, 67, 45, 0.2)",
          //     fontWeight: "bold",
          //   }}
          // />
        ) : (
          <div>Autres</div>
          // <Chip
          //   label="Autres"
          //   style={{
          //     color: "#E3A322",
          //     borderRadius: "8px",
          //     backgroundColor: "rgba(227, 163, 34, 0.2)",
          //     fontWeight: "bold",
          //   }}
          // />
        ),
    },
    realestateupdate ?
    {
      name: "Actions",
      sortable: true,
      width: "8rem",
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Button
              color={"success"}
              className={classes.actionButton}
              onClick={editUser(row)}
            >
              <Edit className={classes.icon} />
            </Button>
            <CustomDeleteButton
              deleteTitle={"Suppression utilisateur"}
              deleteSubTitle={
                "Êtes-vous sûr de vouloir supprimer l'utilisateur ?"
              }
              handleSupprimer={deleteUser(row)}
            />
          </div>
        </>
      ),
    } : {},
  ];

  const [idSelected, setIdSelected] = useState();

  const editUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);
    handleClickOpen();

    setIdSelected(obj.uuid);
    setClef(obj.clef);
    setComments(obj.comments);
    setExternal(obj.external);
    setDescription(obj.description);
    setGed(obj.ged);
    setEmail(obj.email);
    setName(obj.name);
    setStatus(obj.status);
    setRole(obj.role);
    setCompany(obj.company);
    setPhone(obj.phone);
  };

  const deleteUser = (row) => async () => {
    let obj = dataUsers.find((o) => o.uuid === row.uuid);
    const indexToReplace = dataUsers.findIndex((x) => x.uuid === obj.uuid);
    const contactlist = dataUsers;
    contactlist.splice(indexToReplace, 1);

    axios
      .put(
        getSite(chartIdGroup,"contact"),
        { contactlist },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then(() => {
        refetch();
      })
      .catch(() => {});
  };

  const handleClefChange = (e) => {
    setClef(e.target.value);
  };
  const handleAssociatedfilesChange = (newValue) => {
    console.log(newValue);
    setGed(newValue);
  };
  const handleCommentsChange = (e) => {
    setComments(e.target.value);
  };
  const handleSelectValueChange = (e) => {
    setExternal(e.target.value);
  };
  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleRoleChange = (event) => {
    setRole(event.target.value);
  };

  const handleCompanyChange = (event) => {
    setCompany(event.target.value);
  };

  const handlePhoneChange = (event) => {
    setPhone(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  return (
    <>
      <div
        style={{
          marginTop: "-1.8rem ",
          paddingTop: "0.5rem",
          //borderTop: "solid 1.2px rgba(0, 0, 0, 0.15)",
        }}
      >
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          noDataComponent={<NoData>Aucune contact à afficher</NoData>}
          paginationComponentOptions={
            {noRowsPerPage : false,
            rowsPerPageText : "Lignes par page",
            rangeSeparatorText : "sur",
            selectAllRowsItem : false,
            selectAllRowsItemText : "Selectionner toutes les lignes"}
          }
          columns={columns}
          persistTableHead
          pagination
          noHeader={true}
          subHeader
          onSelectedRowsChange={updateState}
          expandOnRowClicked
          expandableRows
          expandableRowDisabled={(row) => row.disabled}
          expandableRowsComponent={ExpandableComponent}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
        <Dialog
          onClose={handleClose}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={open}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            Modification du contact
          </DialogTitle>
          <DialogContent dividers>
            <EditUserDialog
              closeModal={handleClose}
              refetch={refetch}
              idSelected={idSelected}
              clef={clef}
              handleClefChange={handleClefChange}
              comments={comments}
              handleCommentsChange={handleCommentsChange}
              external={external}
              handleSelectValueChange={handleSelectValueChange}
              description={description}
              setDescription={setDescription}
              ged={ged}
              handleAssociatedfilesChange={handleAssociatedfilesChange}
              email={email}
              handleEmailChange={handleEmailChange}
              name={name}
              handleNameChange={handleNameChange}
              status={status}
              handleStatusChange={handleStatusChange}
              role={role}
              handleRoleChange={handleRoleChange}
              company={company}
              handleCompanyChange={handleCompanyChange}
              phone={phone}
              handlePhoneChange={handlePhoneChange}
              handleDescriptionChange={handleDescriptionChange}
            />
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default RTContacts;
